module.exports = new __parcel__URL__("star.7cf291c8.svg").toString();